import { render, staticRenderFns } from "./createStoreForm.vue?vue&type=template&id=3ce97c36&scoped=true"
import script from "./createStoreForm.vue?vue&type=script&lang=ts"
export * from "./createStoreForm.vue?vue&type=script&lang=ts"
import style0 from "./createStoreForm.vue?vue&type=style&index=0&id=3ce97c36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_idpt5aadqkxzu6szyh7dhosqta/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce97c36",
  null
  
)

export default component.exports